module.exports = __webpack_public_path__ + "static/media/servicio_integral.84fb9b51.jpg";